import script from "./HlhtAuthAdd.vue?vue&type=script&lang=ts&setup=true"
export * from "./HlhtAuthAdd.vue?vue&type=script&lang=ts&setup=true"

import "./HlhtAuthAdd.vue?vue&type=style&index=0&id=c0ab16fc&lang=scss"

const __exports__ = script;

export default __exports__